import React from 'react';

import { WhatsApp, Instagram, Facebook } from '@mui/icons-material';

const ConnectionIcon = ({ connectionType }) => {
  return (
    <React.Fragment>
      {connectionType === 'whatsapp' && (
        <WhatsApp
          fontSize='small'
          sx={{
            marginBottom: '-2px',
            color: '#25D366',
            height: '16px',
            width: '16px',
          }}
        />
      )}
      {connectionType === 'instagram' && (
        <Instagram
          fontSize='small'
          sx={{
            marginBottom: '-2px',
            color: '#e1306c',
            height: '16px',
            width: '16px',
          }}
        />
      )}
      {connectionType === 'facebook' && (
        <Facebook
          fontSize='small'
          sx={{
            marginBottom: '-2px',
            color: '#3b5998',
            height: '16px',
            width: '16px',
          }}
        />
      )}
    </React.Fragment>
  );
};

export default ConnectionIcon;
